<template>
  <label class="frm-checkbox w-150px">
    <input tabindex="-1" type="checkbox" :checked="modelValue" :disabled="disabled" @input="inputValue"
      v-bind="$attrs" />
    <span :tabindex="disabled ? '-1' : tabindex" @keydown.space.stop.prevent="toggleChecked"
      class="checkbox-item"></span>
    <span class="checkbox-text" :class="disabled?'grey-text':''">{{ text }}</span>
  </label>
</template>
<script setup>
import { defineProps, defineEmits, watch } from "vue";
const props = defineProps({
  modelValue: {
    required: true,
    default: false,
  },
  disabled: {
    required: true,
    default: false,
  },
  tabindex: {
    type: Number,
    default: 0,
  },
  text: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["update:modelValue"]);
let backup = false;
watch(
  () => props.disabled,
  (val) => {
    if (val) {
      backup = props.modelValue;
      emit("update:modelValue", false);
    } else {
      emit("update:modelValue", backup);
    }
  }
);
const inputValue = (e) => {
  const value = e.target.checked;
  emit("update:modelValue", value);
};

const toggleChecked = () => {
  emit("update:modelValue", !props.modelValue);
};
</script>
